'use client';

import { useEffect } from 'react';

import { ActivityTrackerEventType } from '@/modules/activityTracker/constants';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

type Props = {
  page: string;
};

export function ATPageView({ page }: Props) {
  const [, currentUser] = useCurrentUser();
  const { sendActivityTrackerEvent } = useActivityTracker({
    userId: currentUser?.id,
  });

  useEffect(() => {
    sendActivityTrackerEvent(ActivityTrackerEventType.WEB_PAGE_VIEW, {
      schemaVersion: '3.0',
      page,
    });
  }, []);

  return null;
}
